var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongBaocun(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 2.5V3v-.5zM13 13H3v1h10v-1zM3 13V3H2v10h1zM3 3h7.75V2H3v1zm7.75 0H13V2h-2.25v1zM13 3v10h1V3h-1zm0 0h1a1 1 0 00-1-1v1zM3 13H2a1 1 0 001 1v-1zm10 1a1 1 0 001-1h-1v1zM3 3V2a1 1 0 00-1 1h1z",
    fill: "#3F465C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 2v5h6V2",
    stroke: "#3F465C",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 4.2v1",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })));
}
export default __webpack_public_path__ + "static/tongyong_baocun.bafddd70.svg";
export { SvgTongyongBaocun as ReactComponent };